import React, { useState, useCallback, useEffect } from 'react';
import * as http from 'utils/http';
import config from 'config';
import { Checkbox, Text, Spacer } from '@ontruck/orc';

import SelectUser from './select';

import { preferencesField, preferencesMap, t } from './preferences';

const voidObject = {};

const PreferencesManager = () => {
  const [user, setUser] = useState(null);
  const [userMercuryPreferences, setUserMercuryPreferences] = useState(voidObject);
  const [editing, setEditing] = useState(false);

  const handleChange = useCallback((user) => {
    setUser(user);
    setUserMercuryPreferences(voidObject);
  }, []);

  const defaultPreferences = preferencesMap.mercuryPreferences;
  const { id, preferences: userPreferences = voidObject } = user || voidObject;
  const { [preferencesField]: mercuryPreferences = voidObject } = userPreferences;

  useEffect(() => {
    setUserMercuryPreferences(mercuryPreferences);
  }, [mercuryPreferences]);

  const handleCheckboxChange = useCallback(
    async (_, { name, value }) => {
      setEditing(true);

      const mercuryPreferences = {
        ...userMercuryPreferences,
        [name]: value,
      };

      setUserMercuryPreferences(mercuryPreferences);

      const preferences = {
        ...userPreferences,
        [preferencesField]: mercuryPreferences,
      };

      await http.patch(`${config.API_URL}staff_users/${id}/`, { preferences });

      setEditing(false);
    },
    [userPreferences, userMercuryPreferences, id]
  );

  return (
    <Spacer style={{ width: 600 }} m="L">
      <SelectUser onChange={handleChange} />

      {!!user && (
        <Spacer mTop="M">
          <h2>
            {user.name} - {}
            {user.email}
          </h2>
          <table cellPadding="8">
            {Object.keys(defaultPreferences).map((preference) => {
              return (
                <tr mBottom="XS" key={preference}>
                  <td>
                    {!!t[preference] ? (
                      <>
                        <div>
                          <strong>{t[preference].title}</strong>
                          {!!t[preference].description && (
                            <Text
                              color="grey800"
                              display="block"
                              text={t[preference].description}
                            />
                          )}
                        </div>
                      </>
                    ) : (
                      preference
                    )}
                  </td>
                  <td>
                    <Checkbox
                      label={''}
                      name={preference}
                      size="M"
                      checked={!!userMercuryPreferences[preference]}
                      onChange={handleCheckboxChange}
                      disabled={editing}
                    />
                  </td>
                </tr>
              );
            })}
          </table>
        </Spacer>
      )}
    </Spacer>
  );
};

export default PreferencesManager;
